import httpClient from '../httpClient';

const createQuestionOption = async (data) => {
  return await httpClient.post(`question_option/`, data);
};

const updateQuestionOption = async (id, data) => {
  return await httpClient.put(`question_option/${id}/`, data);
};

const deleteQuestionOption = async (id) => {
  return await httpClient.delete(`question_option/${id}/`);
};

const queryQuestionOptions = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/question_option/?page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
    { params: query },
  );
};

export {
  createQuestionOption,
  updateQuestionOption,
  deleteQuestionOption,
  queryQuestionOptions,
}
